import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import pencilOrange from 'core/assets/svg/pencil-orange.svg';
import icLocked from 'core/assets/svg/icLocked.svg';
import { Tooltip } from 'core/components/tooltip';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import useEditReferral from './use-edit-referral';
import useStyles from './edit-referral.styles';

const EditReferral = ({ fromCheckout, inviter }) => {
  const classes = useStyles();
  const { hasInviter, dirty, canAddEditReferral, isLocked, openReferralSearch } = useEditReferral({
    fromCheckout,
    inviter
  });

  if (!hasInviter && !canAddEditReferral) {
    return null;
  }

  return (
    <Grid container item alignItems="center" className={classes.container}>
      <Label type="infoLabel">REFERRED BY</Label>
      <Label type="infoValue">{hasInviter ? `${inviter.firstName} ${inviter.lastName}` : 'None'}</Label>
      <Button
        color="secondary"
        variant="text"
        onClick={dirty || !canAddEditReferral ? null : openReferralSearch}
        className={classes.link}
      >
        <span className={isLocked ? classes.disabled : ''}>Add a referral</span>
        {isLocked ? (
          <Tooltip
            className={classes.tooltip}
            text="Please update offer price to save changes before adding a referral"
            placement="right"
            smallIcon={{ src: icLocked }}
            iconSize="icon16"
          />
        ) : (
          <img src={pencilOrange} alt={'edit'} className={classes.pencilIcon} />
        )}
      </Button>
    </Grid>
  );
};

EditReferral.propTypes = {
  fromCheckout: PropTypes.bool,
  inviter: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  })
};

EditReferral.defaultProps = {
  fromCheckout: false,
  inviter: null
};

export default EditReferral;
